// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../../assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../../assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../../assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.NumberOfPosts_scroll__lEi4D::-webkit-scrollbar {
  height: 8px;
}
.NumberOfPosts_scroll__lEi4D::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.NumberOfPosts_scroll__lEi4D::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.NumberOfPosts_NumberOfPosts__Mz9Zt {
  display: flex;
  width: 100%;
  grid-column-gap: 5px;
  align-items: center;
}
.NumberOfPosts_NumberOfPosts__Mz9Zt i {
  line-height: 0;
}

.NumberOfPosts_hashtag__xcI9e {
  font-size: 12px !important;
  padding: 1em;
}

.NumberOfPosts_userDetails__aN5nj {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  -webkit-margin-after: 7px;
          margin-block-end: 7px;
}

.NumberOfPosts_mainContainer__s0Fla,
.NumberOfPosts_details__qH8Ln {
  width: 100%;
}

.NumberOfPosts_detailItem__U6aPV {
  -webkit-margin-end: 6px;
          margin-inline-end: 6px;
}

.NumberOfPosts_detailRow__7XR31 {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.NumberOfPosts_sourceName__Jtsze {
  -webkit-margin-start: -5px;
          margin-inline-start: -5px;
  font-size: 12px !important;
  width: 75%;
}

.NumberOfPosts_tableFont__-1O20 {
  font-size: 10px !important;
}

.NumberOfPosts_popper__ZH\\+il {
  background-color: var(--bgColor);
  border-bottom: 1px solid var(--borderColor);
  padding: 9.5px 19.5px;
  display: flex;
  flex-direction: column;
  position: relative;
  top: 3px;
  left: 0;
}
.NumberOfPosts_popper__ZH\\+il .NumberOfPosts_popperItem__fR4Qa {
  display: flex;
  align-items: center;
  grid-column-gap: 9px;
  margin-bottom: 14px;
}

.NumberOfPosts_icons__3H07V svg {
  width: 18px;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/app/components/Tables/Cells/NumberOfPosts/NumberOfPosts.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAnDA;EACE,aAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;AAsDF;AArDE;EACE,cAAA;AAuDJ;;AApDA;EDiGI,0BAAA;EC/FF,YAAA;AAuDF;;AArDA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,yBAAA;UAAA,qBAAA;AAwDF;;AAtDA;;EAEE,WAAA;AAyDF;;AAvDA;EACE,uBAAA;UAAA,sBAAA;AA0DF;;AAxDA;EACE,WAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;AA2DF;;AAzDA;EACE,0BAAA;UAAA,yBAAA;EACA,0BAAA;EACA,UAAA;AA4DF;;AA1DA;EACE,0BAAA;AA6DF;;AA3DA;EACE,gCAAA;EACA,2CAAA;EAEA,qBAAA;EAEA,aAAA;EACA,sBAAA;EAEA,kBAAA;EACA,QAAA;EACA,OAAA;AA2DF;AA3BE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;AA6BJ;;AAzBE;EACE,WAAA;AA4BJ","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.NumberOfPosts {\n  display: flex;\n  width: 100%;\n  grid-column-gap: 5px;\n  align-items: center;\n  i {\n    line-height: 0;\n  }\n}\n.hashtag {\n  @include fontSize(12);\n  padding: 1em;\n}\n.userDetails {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  margin-block-end: 7px;\n}\n.mainContainer,\n.details {\n  width: 100%;\n}\n.detailItem {\n  margin-inline-end: 6px;\n}\n.detailRow {\n  width: 100%;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n}\n.sourceName {\n  margin-inline-start: -5px;\n  font-size: 12px !important;\n  width: 75%;\n}\n.tableFont {\n  font-size: 10px !important;\n}\n.popper {\n  background-color: var(--bgColor);\n  border-bottom: 1px solid var(--borderColor);\n\n  padding: 9.5px 19.5px;\n  // width: 152px;\n  display: flex;\n  flex-direction: column;\n  // margin-inline-start: 10px;\n  position: relative;\n  top: 3px;\n  left: 0;\n\n  // &::before {\n  //   content: '';\n  //   position: absolute;\n  //   display: block;\n  //   left: 50%;\n  //   top: -15px;\n  //   transform: translateX(-6px) rotate(90deg);\n  //   #{$rtl} & {\n  //     transform: translateX(-6px) rotate(-90deg);\n  //   }\n  //   border: 7px solid transparent;\n  //   border-left-color: var(--borderColor);\n  //   z-index: 9;\n  // }\n\n  // &::after {\n  //   content: '';\n  //   position: absolute;\n  //   display: block;\n  //   left: 50%;\n  //   border: 7px solid transparent;\n  //   top: -14px;\n  //   transform: translateX(-6px) rotate(90deg);\n  //   #{$rtl} & {\n  //     transform: translateX(-6px) rotate(-90deg);\n  //   }\n  //   border-left-color: var(--bgColor);\n  //   z-index: 9;\n  // }\n\n  .popperItem {\n    display: flex;\n    align-items: center;\n    grid-column-gap: 9px;\n    margin-bottom: 14px;\n  }\n}\n.icons {\n  svg {\n    width: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `NumberOfPosts_scroll__lEi4D`,
	"NumberOfPosts": `NumberOfPosts_NumberOfPosts__Mz9Zt`,
	"hashtag": `NumberOfPosts_hashtag__xcI9e`,
	"userDetails": `NumberOfPosts_userDetails__aN5nj`,
	"mainContainer": `NumberOfPosts_mainContainer__s0Fla`,
	"details": `NumberOfPosts_details__qH8Ln`,
	"detailItem": `NumberOfPosts_detailItem__U6aPV`,
	"detailRow": `NumberOfPosts_detailRow__7XR31`,
	"sourceName": `NumberOfPosts_sourceName__Jtsze`,
	"tableFont": `NumberOfPosts_tableFont__-1O20`,
	"popper": `NumberOfPosts_popper__ZH+il`,
	"popperItem": `NumberOfPosts_popperItem__fR4Qa`,
	"icons": `NumberOfPosts_icons__3H07V`
};
export default ___CSS_LOADER_EXPORT___;
